module.exports = __webpack_public_path__ + "static/media/bg_note.0fc81803.jpg";